/* eslint-disable max-classes-per-file */
import { type QueryFilters as TanstackQueryFilters } from '@tanstack/react-query';
import { QueryType } from '../../../queries/types';

export class QueryKeys {
	static forAssetDetail( id: number ) {
		return [ 'assets', 'detail', id ];
	}

	static forAllAssetDetails() {
		return [ 'assets', 'detail' ];
	}

	static forAssetRounds( assetID: number ) {
		return [ 'asset', assetID, 'rounds' ];
	}
}

export class QueryFilters {
	static forAssetDetail(
		id?: number,
		{ queryType = 'all' }: { queryType?: QueryType } = {}
	): TanstackQueryFilters {
		return {
			queryKey: id ? QueryKeys.forAssetDetail( id ) : QueryKeys.forAllAssetDetails(),
			type: queryType
		};
	}
}
